import { render, staticRenderFns } from "./success-content.vue?vue&type=template&id=519b516d&scoped=true"
import script from "./success-content.vue?vue&type=script&lang=js"
export * from "./success-content.vue?vue&type=script&lang=js"
import style0 from "./success-content.vue?vue&type=style&index=0&id=519b516d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519b516d",
  null
  
)

export default component.exports